import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=e56973c4"
import script from "./selectProducts.vue?vue&type=script&lang=js"
export * from "./selectProducts.vue?vue&type=script&lang=js"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=e56973c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports